export const INVITE_USER_DATA_REQUEST = 'INVITE_USER_DATA_REQUEST';
export const INVITE_USER_DATA_REQUEST_SUCCESS = 'INVITE_USER_DATA_REQUEST_SUCCESS';
export const INVITE_USER_DATA_REQUEST_FAILURE = 'INVITE_USER_DATA_REQUEST_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_create/redux/constants/invite_user_data.constants.js